<template>

    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>{{ product.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}`">
                            Карточка
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/edit`">
                            Редактировать
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/categories`">
                            Категории
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/options`">
                            Опции
                        </CNavItem>
                        <CNavItem active>
                            Варианты
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CCol sm="4">
                            <CSelect
                                horizontal
                                :options="variantsVariants"
                                :value.sync="selectedVariant"
                                placeholder="Выберите вариант..."
                            />
                        </CCol>
                        <CCol sm="8">
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="addVariant">Добавить</CButton>
                        </CCol>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th>&nbsp;</th>
                                <th>Название</th>
                                <th>Цена</th>
                                <th>&nbsp;</th>
                            </thead>
                            <draggable v-model="variants" tag="tbody">
                                <tr v-for="variant in variants" :key="variant.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ variant.title }}</td>
                                    <td>{{ variant.price }}</td>
                                    <td><CButton @click="removeVariant(variant.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {

        name: 'EntityProductVariants',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },
  
        data () {
            return {
                entity: {},
                product: {},
                variants: [],
                allVariants: [],
                selectedVariant: null
            }
        },
    
        computed: {
            variantsVariants: function() {
                const variantsVariants = [];
                this.allVariants.forEach(variant => {
                    variantsVariants.push({
                        value: variant.id,
                        label: variant.title + ' - ' + variant.price + ' руб.'
                    });
                });
                return variantsVariants;
            }
        },
  
        async mounted() {
            const id = parseInt(this.$route.params.id);
            const product_id = parseInt(this.$route.params.entity_product_id);
            const code = this.$route.params.code;
            await Vue.axios.get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get(`/entities/${id}/entity_products/${product_id}`)
                .then(resp => {
                    this.product = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get(`/entities/${id}/entity_products/get-variants/${product_id}`)
                .then(resp => {
                    this.variants = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get(`/entities/${code}/variants/${id}`)
                .then(resp => {
                    this.setAllVariants(resp.data);
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {

            save() {
                const variants = [];
                let index = 0;
                this.variants.forEach(variant => {
                    variant.position = ++index;
                    variants.push(variant);
                });
                Vue.axios.post(`/entities/${this.entity.id}/entity_products/variants/${this.product.id}`, { variants })
                    .then(() => {
                        this.goBack();
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setAllVariants(variants) {
                this.allVariants = variants.filter(variant => !this.addVariantOption(variant.id));
            },

            addVariantOption(id) {
                let contains = [...this.variants].find(variant => variant.id === id);
                return !!contains;
            },

            addVariant() {
                const selectVariant = this.allVariants.find(variant => variant.id === this.selectedVariant);
                this.variants.push(selectVariant);
                this.allVariants = this.allVariants.filter(variant => variant.id !== selectVariant.id);
                this.setAllVariants(this.allVariants);
            },

            removeVariant(id) {
                const removedVariant = this.variants.find(variant => variant.id === id);
                this.allVariants.push(removedVariant);
                this.variants = this.variants.filter(variant => variant.id !== id);
                this.setAllVariants(this.allVariants);
            },

            goBack() {
                this.$router.push({ path:`/entities/${this.entity.entityType.code}/${this.entity.id}/products/${this.product.id}` })
            }
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
